import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Lock } from 'lucide-react';
import authService from '../../services/authService';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const uid = useMemo(() => params.get('uid') || '', [params]);
  const token = useMemo(() => params.get('token') || '', [params]);

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!uid || !token) {
      setError('Lien invalide: uid/token manquants.');
      return;
    }

    if (!newPassword) {
      setError('Nouveau mot de passe obligatoire.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    setLoading(true);
    try {
      const res = await authService.confirmPasswordReset(uid, token, newPassword);
      setSuccess(res?.message || 'Mot de passe mis à jour avec succès.');
      setTimeout(() => navigate('/login'), 900);
    } catch (err) {
      setError(err.response?.data?.error || 'Impossible de modifier le mot de passe.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-card">
        <h1 className="reset-title">Nouveau mot de passe</h1>
        <p className="reset-subtitle">Définis un nouveau mot de passe pour ton compte.</p>

        {error && <div className="reset-alert reset-alert--error">{error}</div>}
        {success && <div className="reset-alert reset-alert--success">{success}</div>}

        <form onSubmit={handleSubmit} className="reset-form">
          <label className="reset-label">Nouveau mot de passe</label>
          <div className="reset-input">
            <Lock size={18} className="reset-icon" />
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </div>

          <label className="reset-label">Confirmer</label>
          <div className="reset-input">
            <Lock size={18} className="reset-icon" />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </div>

          <button className="reset-submit" type="submit" disabled={loading}>
            {loading ? 'Mise à jour...' : 'Mettre à jour le mot de passe'}
          </button>
        </form>

        <div className="reset-footer">
          <Link to="/login" className="reset-link">Retour à la connexion</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
